import layout from '@/views/layout/layout.vue'
const integralList = r => require.ensure([], () => r(require('@/views/ywt/integral/list.vue')), 'group-ywt-integral')
const memberIntegralList = r => require.ensure([], () => r(require('@/views/ywt/memberIntegral/list.vue')), 'group-ywt-integral')

const ywtIntegral = [
  {
    path: '/ywt/integral',
    name: 'ywt-integral',
    component: layout,
    redirect: '/ywt/integral/list',
    children: [
      {
        path: 'list',
        name: 'ywt-integral-list',
        component: integralList,
        meta: {
          displayName: '积分管理',
          requireAuth: true
        }
      },
      {
        path: 'memberintegrallist',
        name: 'ywt-memberintegral-list',
        component: memberIntegralList,
        meta: {
          displayName: '返款明细',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtIntegral



// WEBPACK FOOTER //
// ./src/router/ywt/integral.js